const config = {
	SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
	GRAPHQL_API_URI: import.meta.env.VITE_GRAPHQL_API_URI,
};

export default config;
